module.exports = __webpack_public_path__ + "img/65.7f07e04.svg";